import Feature from "src/js/stores/user/Feature";
import { NavbarItemIcon } from "./NavbarItemIcon";
import { NavbarItemProps } from "./NavbarItem";
import clsx from "clsx";
import { useBetaFeatureFlag } from "react-migration/lib/user/useFeatureFlag";

export const NavbarItemDesktop = ({
  active,
  children,
  leadIcon,
  leadIconProps = {},
  tailIcon,
  anchorActive,
  ...rest
}: NavbarItemProps) => {
  const hasProjectsBeta = useBetaFeatureFlag(Feature.projectsNavBeta);
  if (!hasProjectsBeta) {
    return (
      <NavbarItemDesktopOld
        active={active}
        leadIcon={leadIcon}
        leadIconProps={leadIconProps}
        tailIcon={tailIcon}
        anchorActive={anchorActive}
        {...rest}
      >
        {children}
      </NavbarItemDesktopOld>
    );
  }
  return (
    <button
      className={clsx(
        "relative group my-2 px-2 gap-x-2 py-1! items-center hidden md:flex cursor-pointer rounded-lg",
        {
          "text-blue-grey-950 hover:bg-neutral-100": !active,
          "text-text-accent-blue bg-background-button-secondary": active,
          "bg-blue-grey-300": anchorActive,
        },
        rest.className
      )}
      aria-current={active}
      {...rest}
    >
      {leadIcon && <NavbarItemIcon icon={leadIcon} {...leadIconProps} />}
      {children && <span className="hidden md:block">{children}</span>}
      {tailIcon && <NavbarItemIcon icon={tailIcon} />}
    </button>
  );
};

/**
 * TODO: Remove this component after the projects beta feature flag is removed.
 * @deprecated Use NavbarItemDesktop instead
 */
export const NavbarItemDesktopOld = ({
  active,
  children,
  leadIcon,
  leadIconProps = {},
  tailIcon,
  anchorActive,
  ...rest
}: NavbarItemProps) => {
  return (
    <button
      className={clsx(
        "relative group h-full px-4 items-center hover:bg-blue-grey-300 hidden md:flex cursor-pointer",
        {
          "text-blue-grey-950": !active,
          "text-platform-blue-700": active,
          "bg-blue-grey-300": anchorActive,
        },
        rest.className
      )}
      aria-current={active}
      {...rest}
    >
      {active && <Line />}
      {leadIcon && <NavbarItemIcon icon={leadIcon} {...leadIconProps} />}
      {children && <span className="hidden md:block p-1">{children}</span>}
      {tailIcon && <NavbarItemIcon icon={tailIcon} />}
    </button>
  );
};

function Line() {
  return (
    <div className="absolute bottom-0 w-[calc(100%-1rem)] h-1 rounded-t-lg left-1/2 transform -translate-x-1/2 ease-in-out duration-100 bg-platform-blue-700" />
  );
}
